import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "card", "tag", "iconWrapper", "icon", "projectField", "projectInput"]

  connect() {
    this.sync()
  }

  sync() {
    this.inputTargets.forEach((input, index) => {
      const selected = input.checked
      const card = this.cardTargets[index]
      const tag = this.tagTargets[index]
      const iconWrapper = this.iconWrapperTargets[index]
      const icon = this.iconTargets[index]

      if (card) {
        card.style.borderColor = selected ? "#a75b2d" : "rgba(255,255,255,0.1)"
        card.style.background = selected ? "rgba(103,59,31,0.42)" : "rgba(255,255,255,0.02)"
      }

      if (tag) {
        tag.style.color = selected ? "#ff8a3d" : "#8f8f93"
      }

      if (iconWrapper) {
        iconWrapper.style.background = selected ? "rgba(232,116,46,0.15)" : "rgba(255,255,255,0.05)"
      }

      if (icon) {
        icon.style.color = selected ? "#e8742e" : "#66666a"
      }
    })

    const selectedInterest = this.inputTargets.find((input) => input.checked)?.value
    const needsProjectName = selectedInterest === "dev" || selectedInterest === "both"

    if (this.hasProjectFieldTarget) {
      this.projectFieldTarget.style.display = needsProjectName ? "flex" : "none"
    }

    if (this.hasProjectInputTarget) {
      this.projectInputTarget.required = needsProjectName
      if (!needsProjectName) this.projectInputTarget.value = ""
    }
  }
}
